export const searchData = (e, projects, setSearchResults) => {
    setSearchResults(
        projects?.filter(dataContainsTerm(e))
    );
  };

const dataContainsTerm = (term) => {
    return function (element) {
        let word = term?.toString().toLowerCase();
        let data = element;
        if (data.firstName.toString().toLowerCase().includes(word) &&
            startsWith(data.firstName.toString().toLowerCase(), word)) {
                return true;
        } else if (data.lastName.toString().toLowerCase().includes(word) || 
            startsWith(data.lastName.toString().toLowerCase(), word)) {
                return true;
        } else if (data.company.toString().toLowerCase().includes(word) || 
        startsWith(data.company.toString().toLowerCase(), word)) {
            return true;
        }

        return false;
    };
};

function startsWith(str, word) {
    return str.lastIndexOf(word, 0) === 0;
}